<template>
  <div class="box-content d-flex justify-content-end">
    <div :class="['back', { active: contentActive }]" @click="close()"></div>
    <div :class="['content', { active: contentActive }]">
      <h4>Selecionar Fornecedor</h4>

      <app-title label="FIAT" />
      <providers-table
        :provider="PROVIDER_FIAT"
        :currencies="AVAILABLE_FIAT_CURRENCIES"
        :selectedProvider="selectedProviders"
        @providerSelected="(item) => providerSelected(item)"
      />

      <app-title label="CRYPTO" />
      <providers-table
        :provider="PROVIDER_CRYPTO"
        :currencies="AVAILABLE_CRYPTO_CURRENCIES"
        :selectedProvider="selectedProviders"
        @providerSelected="(item) => providerSelected(item)"
      />
      <div v-for="provider in visibleProviderInputs" :key="provider">
        <app-title :label="provider" />
        <div
          v-for="currency in selectedProviders[provider]"
          :key="generateProviderCurrencyId(currency.name, provider)"
        >
          <form-input
            className="col-12 form-input"
            :label="`Latência ${currency.name} (s)`"
            v-model="currency.delay"
            :id="`delay-${generateProviderCurrencyId(currency.name, provider)}`"
            :name="`delay-${generateProviderCurrencyId(currency.name, provider)}`"
            type="number"
          />
          <form-money
            v-if="isFakeProvider(provider)"
            className="col-12 form-input"
            :label="`Cotação ${currency.name}`"
            v-model="currency.quote"
            :id="`quote-${generateProviderCurrencyId(currency.name, provider)}`"
            :name="`quote-${generateProviderCurrencyId(currency.name, provider)}`"
            :config="moneyFormat('R$ ', '.', ',', 4)"
          />
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <form-button
            class="col-12 form-input"
            title="Enviar"
            :loading="loading"
            @clicked="onSubmitAction"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProvidersTable from '@domains/pos-operations/components/modalProviders/ProvidersTable.vue'
import { useNoScroll } from '@shared/composables/useNoScroll'
import {
  PROVIDER_FIAT,
  AVAILABLE_FIAT_CURRENCIES,
  PROVIDER_CRYPTO,
  AVAILABLE_CRYPTO_CURRENCIES,
  BC_CODES
} from '@shared/config/exchangesConstants'
import { fetchExchangeRate } from '@shared/services/ms'
import { generateProviderCurrencyId } from '@shared/utils/exchangesHelper'
import { moneyFormat } from '@shared/utils/moneyConfig'
import { formButton, formInput, appTitle, formMoney } from 'tb-design_system-web'
import { useForm } from 'vee-validate'
import { ref, provide, watch, onBeforeMount, computed } from 'vue'
import * as yup from 'yup'

export default {
  name: 'FormModalProviders',

  components: {
    ProvidersTable,
    formButton,
    formInput,
    appTitle,
    formMoney
  },

  props: {
    initialFormData: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    exchangeRate: {
      type: Object,
      required: true
    }
  },

  setup(props, { emit }) {
    const contentActive = ref(false)
    const scroll = ref(false)
    const alreadySubmittedOnce = ref(false)
    const { setNoScroll } = useNoScroll()
    const selectedProviders = ref({})

    onBeforeMount(() => {
      selectedProviders.value = JSON.parse(JSON.stringify(props.initialFormData))
      selectedProviders.value = fkQuotesToDecimal(selectedProviders.value)
      openModal()
    })

    const isFakeProvider = (provider) => {
      return provider === PROVIDER_FIAT.FK || provider === PROVIDER_CRYPTO.FK
    }

    const fkQuotesToDecimal = (boradcastCurrencies) => {
      if (boradcastCurrencies.FK != null && boradcastCurrencies.FK.length > 0) {
        for (const c of boradcastCurrencies.FK) {
          c.quote = parseFloat(c.quote)
        }
      }
      return boradcastCurrencies
    }

    const fkQuotesToScientific = (boradcastCurrencies) => {
      if (boradcastCurrencies.FK.length > 0) {
        for (const c of boradcastCurrencies.FK) {
          c.quote = `${String(c.quote).replace('.', '')}E-4`
        }
      }
      return boradcastCurrencies
    }

    const handleCRSelection = (currency, isSelected) => {
      if (isSelected) {
        selectedProviders.value[PROVIDER_FIAT.CR].push(currency)
      } else {
        selectedProviders.value[PROVIDER_FIAT.CR] = selectedProviders.value[
          PROVIDER_FIAT.CR
        ].filter((c) => c !== currency)
      }
    }

    const handleBCSelection = (currency, isSelected) => {
      if (isSelected) {
        selectedProviders.value[PROVIDER_FIAT.BC].push(BC_CODES[currency])
      } else {
        selectedProviders.value[PROVIDER_FIAT.BC] = selectedProviders.value[
          PROVIDER_FIAT.BC
        ].filter((c) => c !== BC_CODES[currency])
      }
    }

    const handleFKSelection = async (currency, isSelected) => {
      if (isSelected) {
        let initialQuote
        if (props.exchangeRate[currency] != null) {
          initialQuote = props.exchangeRate[currency].split('|')[4]
        } else {
          const response = await fetchExchangeRate(currency)
          initialQuote = response.data.payload.currentPrice
        }
        selectedProviders.value[PROVIDER_FIAT.FK].push({
          name: currency,
          delay: 10,
          quote: parseFloat(initialQuote)
        })
      } else {
        selectedProviders.value[PROVIDER_FIAT.FK] = selectedProviders.value[
          PROVIDER_FIAT.FK
        ].filter((c) => c.name !== currency)
      }
    }

    const handleAVSelection = (currency, isSelected) => {
      if (isSelected) {
        selectedProviders.value[PROVIDER_FIAT.AV].push({
          name: currency,
          delay: 10
        })
      } else {
        selectedProviders.value[PROVIDER_FIAT.AV] = selectedProviders.value[
          PROVIDER_FIAT.AV
        ].filter((c) => c.name !== currency)
      }
    }

    const handleBBSelection = (currency, isSelected) => {
      if (isSelected) {
        selectedProviders.value[PROVIDER_CRYPTO.BB].push({
          name: currency,
          delay: 10
        })
      } else {
        selectedProviders.value[PROVIDER_CRYPTO.BB] = selectedProviders.value[
          PROVIDER_CRYPTO.BB
        ].filter((c) => c.name !== currency)
      }
    }

    const providerHandlers = {
      [PROVIDER_FIAT.CR]: handleCRSelection,
      [PROVIDER_FIAT.BC]: handleBCSelection,
      [PROVIDER_FIAT.FK]: handleFKSelection,
      [PROVIDER_FIAT.AV]: handleAVSelection,
      [PROVIDER_CRYPTO.BB]: handleBBSelection
    }

    const providerSelected = ({ provider, currency, isSelected }) => {
      const handler = providerHandlers[provider]
      handler(currency, isSelected)
    }

    watch(scroll, (newValue) => {
      setNoScroll(newValue)
    })

    provide('alreadySubmittedOnce', alreadySubmittedOnce)

    const onSubmitAction = () => {
      alreadySubmittedOnce.value = true
      return onSubmit()
    }

    const dynamicInputsSchema = yup
      .object()
      .test('delay-quote-rules', 'Valores inválidos', function (values) {
        for (const [key, value] of Object.entries(values || {})) {
          if (key.startsWith('delay-')) {
            if (value == null || value <= 0) {
              return this.createError({
                path: key,
                message: 'Delay deve ser maior que 0'
              })
            }
          }
          if (key.startsWith('quote-')) {
            const n = Number(value)
            if (Number.isNaN(n) || n < 0) {
              return this.createError({
                path: key,
                message: 'Cotação deve ser maior ou igual a 0'
              })
            }
          }
        }
        return true
      })

    const { handleSubmit } = useForm({
      validationSchema: dynamicInputsSchema
    })

    const onSubmit = handleSubmit(async () => {
      const selectedProvidersOut = JSON.parse(JSON.stringify(selectedProviders.value))
      fkQuotesToScientific(selectedProvidersOut)
      emit('onSubmitted', selectedProvidersOut)
    })

    const close = () => {
      contentActive.value = false
      scroll.value = false
      selectedProviders.value = {}
      setTimeout(() => {
        emit('onClose', false)
      }, 300)
    }

    const openModal = () => {
      scroll.value = true
      setTimeout(() => {
        contentActive.value = true
      }, 100)
    }

    const providersWithInputEnable = new Set([
      PROVIDER_FIAT.FK,
      PROVIDER_FIAT.AV,
      PROVIDER_CRYPTO.BB
    ])

    const visibleProviderInputs = computed(() => {
      return Object.keys(selectedProviders.value).filter((provider) => {
        return (
          providersWithInputEnable.has(provider) &&
          (selectedProviders.value[provider]?.length ?? 0) > 0
        )
      })
    })

    return {
      PROVIDER_FIAT,
      AVAILABLE_FIAT_CURRENCIES,
      PROVIDER_CRYPTO,
      AVAILABLE_CRYPTO_CURRENCIES,
      isFakeProvider,
      close,
      onSubmitAction,
      contentActive,
      providerSelected,
      selectedProviders,
      generateProviderCurrencyId,
      moneyFormat,
      visibleProviderInputs
    }
  }
}
</script>

<style lang="scss"></style>
